import React, {useState} from 'react';
import {connect} from 'react-redux';
import './DirectTests.css';
import InvokeFormHandler, {DataRetrievedHandler, PrepareDataFormSavingHandler, NextButtonClickHandler, PreviousButtonClickHandler, FieldContentsChangeHandler, InvokeFormHandlerUsingForm} from '../../../../Utils/General/FormStateHandler';
import SinglePagePanel from '../../../Forms/SinglePagePanel/SinglePagePanel';
import PostEvent from '../../../../Data/PostEvents';
import SimpleCard from '../../../General/SimpleCard/SimpleCard';
import ErrorMessage from '../../../General/ErrorMessage/ErrorMessage';
import { Icon } from '@fluentui/react/lib/Icon';
import TranslateTag from '../../../../Utils/Local/TranslateTag';
import TransformDatesInJson from '../../../../Utils/Local/TransformDatesInJson';
import PopulateFieldsWithNewContents from '../../../../Utils/PageStructure/PopulateFieldsWithNewContents';

const DirectTests = (props) => {

    const [dataEntryErrorStatus, updatedataEntryErrorStatus] = useState({visible: false, message: ''});
    const [errorStatus, updateErrorStatus] = useState({visible: false, message: ''});
    const [isTestSelected, setIsTestSelected] = useState(false);
    const [dataEntryState, setDataEntryState] = useState();
    const [userFormState, setUserFormState] = useState({isFormOpen: false, fullScreen: false, showGrid: true});

    const addIcon = <Icon iconName="Add" />;
    const uiEvent = props.type === "specimen" ? "directtestuievent" : "culturetestuievent";

    const closeFormHandler = () => {
        setIsTestSelected(false);
    }

    const buttonClickHandler = (button) => {
        if (button.UIEvent === undefined) {
            const form = props.forms.filter(f => f.Name === button.key);
            if (form.length > 0) {
                InvokeFormHandlerUsingForm(form, button.id, dataRetrievedSuccessfully, errorWhenRetrievingData);
            }
        } else {
            InvokeFormHandler(button, props.id, props.uievents, props.forms, dataRetrievedSuccessfully, errorWhenRetrievingData);
        }
        setUserFormState({...userFormState, showGrid: false});
    }

    const dataRetrievedSuccessfully = (data, extraInfo) => {
        const state = DataRetrievedHandler(data, extraInfo, props.forms, props.pages, props.lists);
        setDataEntryState({...state, button: extraInfo.button, fieldChanges: [] });
        setUserFormState({...userFormState, isFormOpen: true, formDef: state.formDef, fullScreen: state.formDef.fullScreenOnly});
        setIsTestSelected(true);
    }

    const errorWhenRetrievingData = (response) => {
        updateErrorStatus({visible: true, message: response});
    }

    const errorCloseHandler = () => {
        updateErrorStatus({visible: false, message: ''});
    }

    const nextButtonClickHandler = (page, fieldChangesToUse, sourceOfClick) => {
        dataEntryErrorCloseHandler();
        const state = NextButtonClickHandler(page, fieldChangesToUse, sourceOfClick, dataEntryState);
 
        if (state.error !== "") {
            updatedataEntryErrorStatus({visible: true, message: state.error + TranslateTag("@ValMes@",props.language)});
        } else {
            setDataEntryState(state);
        }
    }

    const previousButtonClickHandler = (page) => {
        dataEntryErrorCloseHandler();
        const state = PreviousButtonClickHandler(page, dataEntryState);
        setDataEntryState(state);
    }

    const formSaveHandler = () => {
        dataEntryErrorCloseHandler();
        const state = PrepareDataFormSavingHandler(dataEntryState, "specimens");
        PostEvent(state.data, eventPostedSuccessfully, errorWhenSavingData, state );
    }

    const fieldContentsChangeHandler = (id, value, extraInfo) => {
        let state = {...dataEntryState};
        if (id === "multiplechanges") {
            for (const item of value) {
                state = FieldContentsChangeHandler(item.key,item.value,extraInfo, props.lists, state);
            }
        } else {
            state = FieldContentsChangeHandler(id,value,extraInfo, props.lists, dataEntryState);
        }
        PopulateFieldsWithNewContents(state.formDef.Pages, state.fieldChanges);
        setDataEntryState(state);
    }

    const dataEntryErrorCloseHandler = () => {
        updatedataEntryErrorStatus({visible: false, message: ""});
    }

    const eventPostedSuccessfully = (data) => {
        const itemToChange = props.data.filter((item => item.id === parseInt(data.id)));
        if (itemToChange.length === 0) {
            props.refresh({ UIEvent: uiEvent});
        } else {
            itemToChange[0].status = "Complete";
        }
        props.startConfig.refresh('update', props.id);
        closeFormHandler();
    }

    const errorWhenSavingData = (response) => {
        updatedataEntryErrorStatus({visible: true, message: response.data});
    }

    const deleteCardHandler = (recordToDelete) => {
        const form = props.config.Name === "directtestpage" ? props.forms.filter(f => f.Name === 'removedirecttestform') : props.forms.filter(f => f.Name === 'removeculturetestform');
        InvokeFormHandlerUsingForm(form, recordToDelete.id, dataRetrievedSuccessfully, errorWhenRetrievingData);
    }

    const dataToDisplay = props.data.map((item) => {
        TransformDatesInJson(item);
        var status = item.Status === "Complete" ? TranslateTag("@GenComC@", props.language) : TranslateTag("@GenReq@", props.language);
        const deleteForm = props.config.Name === "directtestpage" ? props.forms.filter(f => f.Name === 'removedirecttestform') : props.forms.filter(f => f.Name === 'removeculturetestform');
        const form = props.forms.filter(f => f.Name === item.TestName);
        const canDelete = deleteForm.length > 0 && form.length > 0;
        let returnValue = {
            description: item.TestDescription,
            key: item.TestName,
            link: item.TestName,
            status: TranslateTag("@GenStaA@", props.language) + ": " + status,
            requested: TranslateTag("@GenReqA@", props.language) + " " + item.Requested,
            delete: canDelete,
            id: item.Id,
            colour: item.Status === "Complete" ? "green" : "grey",
            lock: false
        }

        if (item.Completed !== undefined && item.Completed !== null ) {
            returnValue.completed = TranslateTag("@GenComD@", props.language) + " " + item.Completed;
        }

        return returnValue;
    })

    const addNewTestButton = {
        id: -1,
        UIEvent: props.type === "specimen" ? "testselectionuievent" : "culturetestselectionuievent",
        space1: "",
        icon: addIcon,
        space2: "",
        text: props.type === "specimen" ? TranslateTag("@TesAddG@", props.language) : TranslateTag("@TesAddH@", props.language),
        colour: "blue",
        centre: true
    }

    dataToDisplay.push(addNewTestButton);

    let dataEntryPanel = (null);
    if (isTestSelected) {
        dataEntryPanel = (<SinglePagePanel
            visible={true}
            currentPage={dataEntryState.currentPage}
            close={closeFormHandler}
            save={formSaveHandler}
            next={nextButtonClickHandler}
            previous={previousButtonClickHandler}
            config={userFormState.formDef}
            fullScreen={false}
            changeHandler={fieldContentsChangeHandler}
            errorCloseHandler={dataEntryErrorCloseHandler}
            language={props.language}
            error={dataEntryErrorStatus}>
        </SinglePagePanel>);
    } 

    return (
        <div className="directtests-content">
            <div className="directtests-top">
                {props.type === "specimen" ? TranslateTag("@SpeDir@", props.language) : TranslateTag("@SpeCulC@", props.language)}
            </div>
            <SimpleCard data={dataToDisplay} onClick={buttonClickHandler} onKeySelect={buttonClickHandler} onDelete={deleteCardHandler}></SimpleCard>
            {dataEntryPanel}
            <ErrorMessage visible={errorStatus.visible} dismissHandler={errorCloseHandler} error={errorStatus.message}></ErrorMessage>
        </div>
    )
}

const mapStateToProps = state => {
    return {
        uievents: state.config.uievents,
        forms: state.config.forms,
        pages: state.config.pages,
        lists: state.config.lists
    };
}

export default connect(mapStateToProps)(DirectTests);
